/* EXTERNAL LINKS */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* SLIDING LINKS */

$('a[href^="#"]').click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top - 80},'slow');
});

/* CHECK FOR MOBILE */

$(document).ready(function() {
  /* MOBILE */
  $(function() {      
      let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
  
      if (isMobile) {
        console.log("MOBILE");
      }
   });
});

/* LINKS IN 2 COLS */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.navigation__menu-content .sub-children-menu ul').forEach(ul => {
    const liCount = ul.querySelectorAll('li').length;
    let columns = 0;

    if (liCount > 30) {
      columns = 3;
    } else if (liCount > 20) {
      columns = 2;
    }

    if (columns > 0) {
      // Apply multi-column layout
      ul.style.columns = columns;
      ul.style.columnGap = '30px';
      ul.style.webkitColumns = columns;
      ul.style.mozColumns = columns;

      // Adjust parent menu width based on number of columns
      const parentMenu = ul.closest('.sub-children-menu');
      if (parentMenu) {
        const currentWidth = parseFloat(window.getComputedStyle(parentMenu).width);
        if (!isNaN(currentWidth)) {
          parentMenu.style.width = (currentWidth * columns) + 'px';
        }
      }
    }
  });
});